var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#B7E3E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8586 19.7281V6.28988C18.8586 5.95449 18.6266 5.68262 18.3403 5.68262H6.49777C6.21152 5.68262 5.97949 5.95449 5.97949 6.28988V19.7281H18.8586Z",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9045 18.7249V5.28671C17.9045 4.95131 17.6725 4.67944 17.3862 4.67944H5.54366C5.25742 4.67944 5.02539 4.95131 5.02539 5.28671V18.7249H17.9045Z",
    fill: "#36B2AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2985 4.80127H16.2773C16.5593 4.80127 16.7879 5.04165 16.7879 5.33819V18.7246H17.809V5.33819C17.809 5.04168 17.5805 4.80127 17.2985 4.80127Z",
    fill: "#15584F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.97949,
    y1: 8.31763,
    x2: 12.1805,
    y2: 8.31763,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.97949,
    y1: 10.8257,
    x2: 12.1805,
    y2: 10.8257,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.97949,
    y1: 13.334,
    x2: 15.5196,
    y2: 13.334,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.97949,
    y1: 15.842,
    x2: 15.5196,
    y2: 15.842,
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 4.8063V4.54098C16.0003 4.28621 15.8032 4.07896 15.5609 4.07896H14.3892C14.1469 4.07896 13.9498 4.28621 13.9498 4.54098V9.98414C13.9498 10.4319 14.2962 10.7961 14.722 10.7961C15.1477 10.7961 15.4941 10.4319 15.4941 9.98414V6.2461C15.4941 6.08543 15.3698 5.95472 15.217 5.95472C15.0642 5.95472 14.9399 6.08543 14.9399 6.2461V8.58012C14.9399 8.69132 14.8542 8.78147 14.7485 8.78147C14.6427 8.78147 14.557 8.69132 14.557 8.58012V6.2461C14.557 5.86339 14.8531 5.55203 15.217 5.55203C15.581 5.55203 15.877 5.86339 15.877 6.2461V9.98414C15.877 10.6539 15.3589 11.1988 14.722 11.1988C14.0851 11.1988 13.5669 10.6539 13.5669 9.98414V4.54098C13.5669 4.06417 13.9358 3.67627 14.3892 3.67627H15.5609C16.0144 3.67627 16.3832 4.06417 16.3832 4.54098V4.8063H16.0003Z",
    fill: "#051029"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note.0c2bf65b5b1d493cd8d7ef2f19b27a57.svg";